export enum QuestionnaireType {
  PRICING = 'PRICING', // 안내받은 가격과 동일해요
  WAITING_TIME = 'WAITING_TIME', // 10분이내로 기다렸어요
  FRIENDLY_STAFF = 'FRIENDLY_STAFF', // 친절하게 응대했어요
  UPSELLING = 'UPSELLING', // 원하는 시술만 받았어요
}

export interface SatisfactionStatisticsContent {
  questionnaireType: QuestionnaireType
  respondentCount: number
  satisfiedCount: number
}
export interface SatisfactionStatistics {
  totalRespondent: number
  totalRating: number
  contents: SatisfactionStatisticsContent[]
}
